/** GST / tax rate applied on rental cost across guest booking UI */
export const TAX_RATE = 0.18;
export const TAX_PERCENT = 18;
export const TAX_MULTIPLIER = 1 + TAX_RATE;

export const calcTaxAmount = (rentalCost) =>
  Math.floor(TAX_RATE * Number(rentalCost || 0));

export const calcTotalWithTax = (rentalCost) =>
  Math.floor(TAX_MULTIPLIER * Number(rentalCost || 0));

/**
 * Split price into rental + tax.
 * Listed prices are treated as rental (tax exclusive); tax is always 18% on top.
 */
export const splitPriceWithTax = (price) => {
  const rentalCost = Math.floor(Number(price || 0));
  const totalCost = calcTotalWithTax(rentalCost);
  const taxCost = totalCost - rentalCost;
  return { rentalCost, taxCost, totalCost };
};
